var _rect, _rect2, _text, _text2, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFmohLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 90,
    viewBox: "0 0 220 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 8,
    height: 90,
    fill: "#008751"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0,
    width: 4,
    height: 90,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 36,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 11,
    fill: "#2A2A2A",
    letterSpacing: 1
  }, "Federal Ministry of Health")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 52,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 11,
    fill: "#2A2A2A",
    letterSpacing: 1
  }, "and Social Welfare")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 68,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 400,
    fontSize: 9,
    fill: "#008751",
    letterSpacing: 2
  }, "NIGERIA")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 84,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 400,
    fontSize: 7,
    fill: "#888",
    letterSpacing: 1
  }, "FMOH&amp;SW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmohLogo);
export default __webpack_public_path__ + "static/media/fmoh-logo.144f428ab21b887bbaa4013a4a9b69bb.svg";
export { ForwardRef as ReactComponent };